import { useCallback, useMemo, useState } from "react"

interface AccountFormProps {
  isEnterprise: boolean
  shouldPayByInvoice?: boolean
}

const useAccountForm = (initialState: AccountFormProps) => {
  const [formData, setFormData] = useState<AccountFormProps>(initialState)

  const isValidAccountForm = useMemo(() => {
    const accountValues = Object.values({ ...formData })

    return !accountValues.some((value) => value === null)
  }, [formData])

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value
      }))
    },
    [setFormData]
  )

  const handleToggle = useCallback(
    (key: string) => {
      const updatedState = {
        ...formData,
        [key]: !formData[key]
      }

      if (key === "isEnterprise" && !updatedState.isEnterprise) {
        updatedState.shouldPayByInvoice = false
      }

      setFormData(updatedState)
    },
    [setFormData, formData]
  )

  const resetFormData = useCallback(() => {
    setFormData(initialState)
  }, [])

  const overwriteFormData = useCallback((data) => {
    setFormData(data)
  }, [])

  return {
    formData,
    isValidAccountForm,
    handleChange,
    handleToggle,
    overwriteFormData,
    resetFormData
  }
}

export default useAccountForm
